import { render, staticRenderFns } from "./tab-planos.vue?vue&type=template&id=3a53cdd4&scoped=true&"
import script from "./tab-planos.vue?vue&type=script&lang=js&"
export * from "./tab-planos.vue?vue&type=script&lang=js&"
import style0 from "./tab-planos.vue?vue&type=style&index=0&id=3a53cdd4&scoped=true&lang=css&"
import style1 from "./tab-planos.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a53cdd4",
  null
  
)

export default component.exports